(() => {
  function bindCookiePreferences(footer) {
    let opening = false;
    const fallback = () => { if (footer.isConnected) window.location.hash = 'shopifyReshowConsentBanner'; };
    const click = event => {
      const link = event.target.closest?.('a');
      if (!link || !footer.contains(link) || link.getAttribute('href')?.split('#')[1] !== 'shopifyReshowConsentBanner') return;
      link.setAttribute('href', '#shopifyReshowConsentBanner');
      if (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const banner = window.privacyBanner;
      if (typeof banner?.showPreferences !== 'function') return;
      event.preventDefault();
      event.stopPropagation();
      if (opening) return;
      opening = true;
      try {
        Promise.resolve(banner.showPreferences()).catch(fallback).finally(() => { opening = false; });
      } catch {
        opening = false;
        fallback();
      }
    };
    footer.addEventListener('click', click);
    const unload = event => {
      if (!event.target.contains(footer)) return;
      footer.removeEventListener('click', click);
      document.removeEventListener('shopify:section:unload', unload);
    };
    document.addEventListener('shopify:section:unload', unload);
  }
  function bindNavigation(footer) {
    const groups = [...footer.querySelectorAll('.marame-figma-footer__navigation details')];
    const desktop = matchMedia('(min-width: 1024px)');
    const mobileState = new Map(groups.map(group => [group, group.open]));
    let wasDesktop = false;
    const update = () => {
      if (desktop.matches) {
        if (!wasDesktop) groups.forEach(group => mobileState.set(group, group.open));
        groups.forEach(group => { group.open = true; });
      } else if (wasDesktop) groups.forEach(group => { group.open = mobileState.get(group); });
      wasDesktop = desktop.matches;
    };
    update();
    desktop.addEventListener('change', update);
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(footer)) desktop.removeEventListener('change', update);
    });
  }
  function bindDiscount(footer) {
    const count = footer.querySelector('[data-discount-count]');
    const display = footer.querySelector('[data-discount-display]');
    if (!count || !display) return;
    const maximum = Number(count.dataset.discountCount);
    if (!Number.isInteger(maximum) || maximum <= 0 || maximum > 50) return;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    if (!('IntersectionObserver' in window)) return;
    let timers = [], visible = false;
    const stop = () => {
      timers.forEach(clearTimeout);
      timers = [];
      count.textContent = String(maximum);
      display.style.opacity = '1';
    };
    const cycle = () => {
      stop();
      if (!visible || document.hidden || reduced.matches) return;
      count.textContent = '0';
      for (let number = 1; number <= maximum; number += 1) {
        timers.push(setTimeout(() => { count.textContent = String(number); }, number * 1000 / maximum));
      }
      timers.push(setTimeout(() => { display.style.opacity = '0'; }, 3600));
      timers.push(setTimeout(cycle, 4500));
    };
    const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; cycle(); });
    observer.observe(display);
    document.addEventListener('visibilitychange', cycle);
    reduced.addEventListener('change', cycle);
    window.addEventListener('pagehide', stop, { once: true });
    document.addEventListener('shopify:section:unload', event => {
      if (!event.target.contains(footer)) return;
      stop();
      observer.disconnect();
      document.removeEventListener('visibilitychange', cycle);
      reduced.removeEventListener('change', cycle);
    });
  }
  function bind(root) {
    root.querySelectorAll('[data-marame-figma-footer]').forEach(footer => {
      if (footer.dataset.bound) return;
      footer.dataset.bound = 'true';
      bindCookiePreferences(footer);
      bindDiscount(footer);
      bindNavigation(footer);
      const country = footer.querySelector('[data-country-selector]');
      if (country) { country.form.dataset.autoSubmit = 'true'; country.addEventListener('change', () => country.form.requestSubmit()); }
      const logos = footer.querySelector('[data-press-logos]');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      if (!logos || reduced.matches || !('IntersectionObserver' in window)) return;
      const items = [...logos.children];
      if (items.length <= 2) return;
      let cursor = 0, timer, fade, visible = false;
      const stop = () => { clearInterval(timer); clearTimeout(fade); logos.style.opacity = ''; };
      const tick = () => {
        logos.style.opacity = '0';
        fade = setTimeout(() => { cursor = (cursor + 2) % items.length; items.forEach((item,index) => { item.hidden = index !== cursor && index !== (cursor + 1) % items.length; }); logos.style.opacity = '1'; }, 650);
      };
      const start = () => { stop(); if (visible && !document.hidden && !reduced.matches) timer = setInterval(tick, 3200); };
      const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; start(); });
      observer.observe(logos);
      document.addEventListener('visibilitychange', start);
      reduced.addEventListener('change', start);
      window.addEventListener('pagehide', stop, {once:true});
      document.addEventListener('shopify:section:unload', event => { if (event.target.contains(footer)) { stop(); observer.disconnect(); document.removeEventListener('visibilitychange', start); reduced.removeEventListener('change',start); } });
    });
  }
  bind(document);
  document.addEventListener('shopify:section:load', event => bind(event.target));
})();
